/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_GeneralInputs */

const en_us2_body_measures_how_general = /** @type {(inputs: Body_Measures_How_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tape flat on the skin and level with the floor, neither tight nor loose. Always measure at the same time, ideally in the morning, before eating and training.`)
};

const pt_br2_body_measures_how_general = /** @type {(inputs: Body_Measures_How_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fita rente à pele e paralela ao chão, sem apertar nem deixar folga. Meça sempre no mesmo horário, de preferência de manhã, antes de comer e de treinar.`)
};

const es_419_body_measures_how_general = /** @type {(inputs: Body_Measures_How_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinta pegada a la piel y paralela al piso, sin apretar ni dejar holgura. Mide siempre a la misma hora, de preferencia en la mañana, antes de comer y de entrenar.`)
};

const pt_pt2_body_measures_how_general = /** @type {(inputs: Body_Measures_How_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fita rente à pele e paralela ao chão, sem apertar nem deixar folga. Mede sempre à mesma hora, de preferência de manhã, antes de comer e de treinar.`)
};

const fr_fr2_body_measures_how_general = /** @type {(inputs: Body_Measures_How_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruban à plat sur la peau et parallèle au sol, ni serré ni lâche. Mesure toujours à la même heure, idéalement le matin, avant de manger et de t'entraîner.`)
};

const de_de2_body_measures_how_general = /** @type {(inputs: Body_Measures_How_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maßband flach auf der Haut und parallel zum Boden, weder straff noch locker. Miss immer zur selben Zeit, am besten morgens vor dem Essen und vor dem Training.`)
};

const it_it2_body_measures_how_general = /** @type {(inputs: Body_Measures_How_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metro aderente alla pelle e parallelo al pavimento, né stretto né lento. Misura sempre alla stessa ora, meglio di mattina, prima di mangiare e di allenarti.`)
};

/**
* | output |
* | --- |
* | "Tape flat on the skin and level with the floor, neither tight nor loose. Always measure at the same time, ideally in the morning, before eating and training." |
*
* @param {Body_Measures_How_GeneralInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_general = /** @type {((inputs?: Body_Measures_How_GeneralInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_GeneralInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_general(inputs)
	if (locale === "es-419") return es_419_body_measures_how_general(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_general(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_general(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_general(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_general(inputs)
	return en_us2_body_measures_how_general(inputs)
});
export { body_measures_how_general as "body-measures.how_general" }